import axios from 'axios';

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="api-token"]');
if(token) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token.content;
}

export default axios;
